if (window.location.href.includes("en-row")) {
    document.querySelector(".drawer-location-en")?.classList.add("active-location");
}
document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
    const handleToggle = function (e) {
        const submenu = this.nextElementSibling;
        if (!submenu?.classList.contains('menu-drawer__submenu')) return;
        e.preventDefault();

        const isActive = submenu.classList.contains('active');

        const getSubmenuHeight = (submenu) => {
            submenu.style.height = "auto";
            let height = submenu.scrollHeight;
            submenu.style.height = "0";
            return height;
        };

        const setAriaExpanded = (trigger, expanded) => {
            if (trigger && trigger.hasAttribute('aria-expanded')) {
                trigger.setAttribute('aria-expanded', String(expanded));
            }
        };

        const syncCloseButton = (sub, expanded) => {
            const closeBtn = sub.querySelector('.menu-drawer__close-button');
            setAriaExpanded(closeBtn, expanded);
        };

        const closeOtherSubmenus = () => {
            document.querySelectorAll('.menu-drawer__submenu.active').forEach(activeSub => {
                if (activeSub !== submenu) {
                    activeSub.style.height = `${activeSub.scrollHeight}px`;
                    requestAnimationFrame(() => {
                        activeSub.style.height = '0';
                        setTimeout(() => {
                            activeSub.classList.remove('active');
                            const trigger = activeSub.previousElementSibling;
                            trigger?.classList.remove('active');
                            setAriaExpanded(trigger, false);
                            syncCloseButton(activeSub, false);
                        }, 300);
                    });
                }
            });
        };

        if (isActive) {
            submenu.style.height = `${submenu.scrollHeight}px`;
            requestAnimationFrame(() => {
                submenu.style.height = '0';
                setTimeout(() => {
                    submenu.classList.remove('active');
                    this.classList.remove('active');
                    setAriaExpanded(this, false);
                    syncCloseButton(submenu, false);
                }, 300);
            });
        } else {
            closeOtherSubmenus();
            submenu.classList.add('active');
            this.classList.add('active');
            setAriaExpanded(this, true);
            syncCloseButton(submenu, true);

            let submenuHeight = getSubmenuHeight(submenu);
            requestAnimationFrame(() => {
                submenu.style.height = `${submenuHeight}px`;
            });
        }
    };

    item.addEventListener('click', handleToggle);
    item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            const submenu = this.nextElementSibling;
            if (!submenu?.classList.contains('menu-drawer__submenu')) return;
            e.preventDefault();
            handleToggle.call(this, e);
        }
    });
});

// Auto-open the first top-level submenu (Shoes)
const firstTrigger = document.querySelector(
    '.mobile-nav-menu > li:first-child > div > .menu-drawer__menu-item'
);
if (firstTrigger) {
    const submenu = firstTrigger.nextElementSibling;
    if (submenu?.classList.contains('menu-drawer__submenu')) {
        submenu.classList.add('active');
        firstTrigger.classList.add('active');
        if (firstTrigger.hasAttribute('aria-expanded')) {
            firstTrigger.setAttribute('aria-expanded', 'true');
        }
        submenu.style.height = 'auto';
    }
}
